import GetAppIcon from '@material-ui/icons/GetApp';
import React from 'react';
import Button from '../Button';
import { IDownloadButton } from './interface';

function DownloadButton(props: IDownloadButton) {
  return (
    <Button.Default gridArea={props.gridArea} onClick={props.onClick}>
      <GetAppIcon />
      {props.children}
    </Button.Default>
  );
}

export default DownloadButton;
